import { render } from "./RandomPrompt.vue?vue&type=template&id=a98f7928&scoped=true"
import script from "./RandomPrompt.vue?vue&type=script&lang=js"
export * from "./RandomPrompt.vue?vue&type=script&lang=js"

import "./RandomPrompt.vue?vue&type=style&index=0&id=a98f7928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98f7928"]])

export default __exports__